import { match } from 'ts-pattern';

import type {
  OfferFeedItem,
  OfferFeedType,
} from '~/services/marketplace/marketplace-service.schemas';
import { OFFER_FEED_TYPES } from '~/services/marketplace/marketplace-service.schemas';

export const OFFER_FEED_KINDS = ['offer', 'counter', 'accepted'] as const;

export type OfferFeedKind = (typeof OFFER_FEED_KINDS)[number];

const isKnownOfferFeedType = (type: string): type is OfferFeedType =>
  (OFFER_FEED_TYPES as readonly string[]).includes(type);

export const resolveOfferFeedKind = (item: OfferFeedItem): OfferFeedKind | null => {
  if (!isKnownOfferFeedType(item.type)) {
    return null;
  }

  return match(item.type)
    .with('offer_received', (): OfferFeedKind => 'offer')
    .with('counter_received', (): OfferFeedKind => 'counter')
    .with('offer_accepted', (): OfferFeedKind => 'accepted')
    .with('offer_declined', 'offer_cancelled', 'offer_expired', 'offer_failed', () => null)
    .exhaustive();
};

export const resolveOfferFeedTerms = (item: OfferFeedItem, kind: OfferFeedKind) =>
  kind === 'counter'
    ? {
        priceDollars: item.counterPriceDollars ?? item.priceDollars,
        shareBps: item.counterShareBps ?? item.shareBps,
      }
    : { priceDollars: item.priceDollars, shareBps: item.shareBps };
